/*
 * セッション期限切れを検出するcatchを挟み込むためのPromiseラッパー
 */
export default class PromiseProxy {

  constructor (promise, sessionExpiredHandler) {
      this.promise = promise;
      this.sessionExpiredHandler = sessionExpiredHandler;
      this.addedSessionExpiredCatch = false;
  }

  then (handler) {
    this.promise = this.promise.then(handler);
    return this;
  }

  catch (handler) {
    if (!this.addedSessionExpiredCatch) {
      this.promise = this.promise.catch(err => {
        if (PromiseProxy.sessionExpired(err)) {
          if (this.sessionExpiredHandler) {
            this.sessionExpiredHandler();
          }
          else {
            // pass to next catch
            return Promise.reject(err);
          }
        }
        else {
          // pass to next catch
          return Promise.reject(err);
        }
      })
      this.addedSessionExpiredCatch = true;
    }

    this.promise = this.promise.catch(handler);
    return this;
  }

  static sessionExpired (err) {
    if (err.response) {
      let res = err.response;
      let authReq = res.config.headers
          && res.config.headers['Authorization']
          && res.config.headers['Authorization'].length > 0;
      let unauthorized = (res.status === 401);
      return (authReq && unauthorized);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./app-common-vue/src/lib/PromiseProxy.js